import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Admin from "../pages/Admin";
import Register from "../pages/Register";
import ToursHome from "../pages/Tour/Home";
import TourDetails from "../pages/Tour/TourDetails";
import TourView from "../pages/Tour/Admin/ViewTour";
import UpdateTour from "../pages/Tour/Admin/updateAddedTour";
import SearchResults from "../pages/Tour/SerachResults";
import AllTourCategories from "../components/Tour/AllTourCategories";
import AddTourPackage from "../pages/Tour/Admin/AddTourPackage";
import { AuthContext } from "../context/authContext";
import { tourReservationColumns } from "../components/datatable/datatablesource";
import UserpageA from "../pages/UserpageA";
import Adduser from "../pages/Adduser";
import ResetPassword from "../pages/ResetPassword";
import Tourreservations from "../pages/Tourreservations";
import UserList from "../pages/UserList.jsx";
import Reservations from "../pages/Reservations";
import EnquiryConfirmation from "../pages/Tour/Services/EnquiryConfirmation";
import UserBookings from "../pages/Tour/UserBookings";
import WishlistTable from "../components/Tour/WishlistTable";
import Reviews from "../pages/Reviews.jsx";
import MailTemplates from "../pages/MailTemplates.jsx";
import GetAllTourList from "../pages/GetAllTourList.jsx";
import UserReviewsTablePage from "../pages/Tour/UserReviewsPage.jsx";
import ContactEnquiry from "../pages/ContactEnquiry.jsx";
import AdminCategoryCountry from "../pages/Tour/Admin/AdminCategoryCountry.jsx";
import AgencyRegister from "../pages/AgencyRegister.jsx";
import AgencyRequests from "../pages/AgencyRequests.jsx";
import UserProfile from "../pages/UserProfile.jsx";

const RouteTour = () => {
  const ProtectedRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (!user) {
      return <Navigate to="/login" />;
    }
    return children;
  };

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        }
      >
        <Route index element={<AddTourPackage />} />
        <Route path="mail" element={<MailTemplates />} />
        <Route path="addtour" element={<AddTourPackage />} />
        <Route path="category-region" element={<AdminCategoryCountry />} />
        <Route path="tourlist" element={<GetAllTourList />} />

        <Route path="reservations" element={<Reservations />} />
        <Route path="users" element={<UserList />} />
        <Route path="reviews" element={<Reviews />} />
        <Route path="contact-enquiry" element={<ContactEnquiry />} />
        <Route path="agency-requests" element={<AgencyRequests />} />
      </Route>
      <Route path="/register" element={<Register />} />
      <Route path="/agency-register" element={<AgencyRegister />} />

      <Route
        path="/users"
        element={
          <ProtectedRoute>
          </ProtectedRoute>
        }
      />

      <Route
        path="/tourreservation/all"
        element={
          <ProtectedRoute>
            <Tourreservations columns={tourReservationColumns} />
          </ProtectedRoute>
        }
      />
      <Route path="/enquiry-confirmation" element={<EnquiryConfirmation />} />
      
      <Route path="/userpage" element={<UserpageA />} />
      <Route path="/adduser" element={<Adduser />} />
      <Route path="/package-history" element={<UserBookings />} />
      <Route path="/profile" element={<UserProfile />} />
      <Route path="/wishlist" element={<WishlistTable />} />
      <Route path="/reviews-rating" element={<UserReviewsTablePage />} />
      <Route path="/tours/edit/:id" element={<AddTourPackage />} />
      <Route path="/tours/home" element={<ToursHome />} />
      <Route path="/tours/:id" element={<TourDetails />} />
      <Route
        path="/tours/search/:destination/:duration/:maxsize"
        element={<SearchResults />}
      />
      <Route path="/addtour" element={<AddTourPackage />} />
      <Route path="/tour/view" element={<TourView />} />
      <Route path="/tour/update" element={<UpdateTour />} />

      <Route path="/packagelist" element={<AllTourCategories />} />

    </Routes>
  );
};

export default RouteTour;
